import { Observable } from 'rxjs/Observable';
import { AuthService } from './auth.service';
import { SecurityService } from './../security/security.service';
import { Resolve, Router, ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { LoginModel } from '../security/security/login-and-register/login.model';


@Injectable()
export class UserActivationResolver implements Resolve<string> {

    constructor(private securityService: SecurityService,
        private authService: AuthService,
        private router: Router) { }

    resolve(activatedRoute: ActivatedRouteSnapshot):Observable<string> {
        if (this.authService.isAuthenticated())
            this.securityService.logout();
        try {
            let email: string = decodeURIComponent(atob(activatedRoute.paramMap.get('email')));
            let password: string = atob(decodeURIComponent(activatedRoute.paramMap.get('password')));         
            let alias: string = activatedRoute.paramMap.get('type');
            const model=<LoginModel>{
                programAlias:alias,
                password:password,
                user:email
            };
            return this.securityService.login(model)
            .map(()=>{
                return Observable.of<string>(password);
            }).catch((e) => {
                this.router.navigate(['/security',alias,'login']);
                this.authService.toastr.error('Error in activation enrollee.Your link might be expired. Otherwise, please contact server admin.');
                return Observable.of(e);
            });
        } catch (error) {
            this.authService.toastr.error(`Cannot proccess user activation parameters for user`);
            return Observable.of(null);
        }

    }
}


// WEBPACK FOOTER //
// ./src/app/auth/user-activation.resolver.ts